module.exports = __webpack_public_path__ + "ro.svg?bbddf824ee23d5d4fc2c3cba47f60bfc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ro.svg
// module id = 1364
// module chunks = 27